module.exports = __webpack_public_path__ + "img/btn_submit.f2c29b15.png";